function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import BaseTemplate from "/components/templates/base-template";
import { MAIN_ID } from "constants/element-ids";
import CoreAddonsComponent from "/components/addons/core-addons/core-addons-component";
import { DirectoryComponent, DirectoryHeaderComponent } from "/components/core/directory";
import { THUMBNAILS_TYPES } from "/constants/thumbnails-types";
import { StyledDirectoryTemplateComponent } from "./directory-images-template.scss";
import { itemFilterValidator } from "/services/directories-service";
import BaseHeaderComponent from "segments/desktop/header/layouts/base-header/base-header-component"; //new for monday 2.0
import LongFooterComponent from "segments/desktop/footer/layouts/long-footer/long-footer-component"; // //new for monday 2.0
class DirectoryImagesTemplate extends PureComponent {
    onSearchChange(value) {
        this.setState({
            searchValue: value
        });
    }
    filterValidator(item) {
        const { searchValue } = this.state;
        return itemFilterValidator(item, searchValue);
    }
    render() {
        const { exitPopup } = this.props;
        const { header, listData, socialButtons, topBanner, exitPopupConfig } = this.props.pageConfig;
        const { searchValue } = this.state;
        return /*#__PURE__*/ _jsx(BaseTemplate, _object_spread_props(_object_spread({}, this.props, this.props.pageConfig), {
            children: /*#__PURE__*/ _jsxs(StyledDirectoryTemplateComponent, {
                className: "directory-template-component",
                children: [
                    /*#__PURE__*/ _jsx(BaseHeaderComponent, {
                        allowSocialButtons: socialButtons && socialButtons.show,
                        socialButtonsColor: socialButtons && socialButtons.color,
                        socialButtonBlogStyle: socialButtons && socialButtons.blogStyle,
                        topBanner: topBanner,
                        maxWidth: "100%",
                        showMenu: true,
                        headerBackgroundColor: "white"
                    }),
                    header && /*#__PURE__*/ _jsx(DirectoryHeaderComponent, _object_spread_props(_object_spread({}, header), {
                        searchValue: searchValue,
                        onSearchChange: this.onSearchChange
                    })),
                    /*#__PURE__*/ _jsx("main", {
                        className: "directory-component-wrapper",
                        id: MAIN_ID,
                        children: /*#__PURE__*/ _jsx(DirectoryComponent, {
                            filterTerm: searchValue,
                            tuhmbnailsListData: listData,
                            thumbnailType: THUMBNAILS_TYPES.BACKGROUND_IMAGE,
                            filterValidator: this.filterValidator
                        })
                    }),
                    /*#__PURE__*/ _jsx(LongFooterComponent, {}),
                    /*#__PURE__*/ _jsx(CoreAddonsComponent, {
                        exitPopup: exitPopup,
                        exitPopupConfig: exitPopupConfig
                    })
                ]
            })
        }));
    }
    constructor(props){
        super(props);
        this.state = {
            searchValue: null
        };
        this.onSearchChange = this.onSearchChange.bind(this);
        this.filterValidator = this.filterValidator.bind(this);
    }
}
export { DirectoryImagesTemplate as default };
DirectoryImagesTemplate.defaultProps = {
    exitPopup: true,
    pageConfig: {
        header: {
            color: "brand-red",
            text: "sdkhjdsjhkds",
            height: "360px",
            img: "/static/img/strips/strip-computer-coffee.png"
        },
        listData: [],
        footerSignup: {
            title: "Start using monday.com today",
            subtitle: "Try it now for free / No credit card needed"
        }
    }
};
